document.querySelector(".a11y-controls__inc-font").addEventListener("click", () => {
  if ((document.querySelector("body").style.zoom === "") || (document.querySelector("body").style.zoom === "1")) {
    document.querySelector("body").style.zoom = "1.1";
    localStorage.setItem("zoomEcrie", "1.1");
  } else if (document.querySelector("body").style.zoom === "1.1") {
      document.querySelector("body").style.zoom = "1.2";
      localStorage.setItem("zoomEcrie", "1.2");
  } else if (document.querySelector("body").style.zoom === "0.9") {
      document.querySelector("body").style.zoom = "1";
      localStorage.setItem("zoomEcrie", "1");
  } else if (document.querySelector("body").style.zoom === "0.8") {
      document.querySelector("body").style.zoom = "0.9";
      localStorage.setItem("zoomEcrie", "0.9");
  }
})

document.querySelector(".a11y-controls__dec-font").addEventListener("click", () => {
  if (document.querySelector("body").style.zoom === "1.2") {
    document.querySelector("body").style.zoom = "1.1";
    localStorage.setItem("zoomEcrie", "1.1");
  } else if (document.querySelector("body").style.zoom === "1.1") {
      document.querySelector("body").style.zoom = "1";
      localStorage.setItem("zoomEcrie", "1");
  } else if ((document.querySelector("body").style.zoom === "1") || (document.querySelector("body").style.zoom === "")) {
      document.querySelector("body").style.zoom = "0.9";
      localStorage.setItem("zoomEcrie", "0.9");
  } else if (document.querySelector("body").style.zoom === "0.9") {
      document.querySelector("body").style.zoom = "0.8";
      localStorage.setItem("zoomEcrie", "0.8");
  }
})